import { addBasePath, addLocale, getDomainLocale } from 'next/dist/next-server/lib/router/router';

/**
 * @param {object} router
 * @param {string} [pathname]
 * @param {string} [locale]
 * @return {string}
 */
const getUrl = ({ router, pathname, locale }) => {
  const localeDomain = router.isLocaleDomain && getDomainLocale(
    pathname || router.pathname,
    locale || router.locale,
    router.locales,
    router.domainLocales,
  );

  return localeDomain || addBasePath(addLocale(
    pathname || router.pathname,
    locale || router.locale,
    router.defaultLocale,
  ));
};

export default getUrl;
